<template>
  <div :class="$style['mobile-nav__header']">
    <div class="d-flex">
      <button :class="$style.wrapper" @click="$listeners.click">
        <IconSelect
          v-show="!open"
          :class="$style['menu-icon']"
          icon="menu"
          height="44"
          width="44"
        />
      </button>
      <!-- <a :href="dashboardUrl">
        <PonLogoSmall />
      </a> -->

      <div :class="$style.blockingIconWrapper">
        <AccountBlockNotification />
      </div>
    </div>

    <div class="d-flex align-center mr-n4">
      <NavigationElement
        v-for="item in mobileList"
        v-bind="item"
        :key="item.url"
        :class="item.attributes.component === 'FavoritesDialog' ? '' : $style['compare-list']"
      />
      <MiniBasketDialog :disabled="appShopModus">
        <MobileMiniBasket :class="$style.basket" :disabled="appShopModus" />
      </MiniBasketDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'
import NavigationElement from '@/js/components/Navigation/NavigationElement.vue'
// import PonLogoSmall from '@/js/components/Shared/SvgSelect/SVG/PonLogoSmall.vue'

import MobileMiniBasket from '@/js/components/Basket/Mini/mobile/MobileMiniBasket.vue'
import MiniBasketDialog from '@/js/components/Basket/Mini/MiniBasketDialog.vue'
import AccountBlockNotification from '@/js/components/Notifications/AccountBlockNotification.vue'

export default {
  name: 'MobileMenuHeader',
  components: {
    IconSelect,
    NavigationElement,
    MobileMiniBasket,
    MiniBasketDialog,
    AccountBlockNotification,
    // PonLogoSmall,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    mobileList: {
      type: Array,
      default: () => [],
    },
    dashboardUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      appShopModus: APP_GETTER.SHOPMODUS,
    }),
  },
}
</script>

<style lang="scss" module>
.mobile-nav__header {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;

  svg {
    display: block;
    width: 35px;
    height: 100%;
    stroke-width: 1;
  }
}

.menu-icon {
  color: var(--black);
}

.wrapper {
  display: flex;
  align-items: center;
  margin-right: 1.5rem;

  outline: 0 none;

  cursor: pointer;

  pointer-events: all;
}

.compare-list {
  :global(.v-btn__content) {
    flex-direction: column !important;
  }

  svg {
    display: block !important;

    color: var(--primary);
  }

  span [class$='iconCount'] {
    right: 17px;
    bottom: 0px;
  }

  span [class$='title'] {
    right: 17px;
    bottom: 0px;

    display: none;
  }
}

.blockingIconWrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
